module.exports = __webpack_public_path__ + "media/images/number_9_green-9d2a28674b9071caa7e2b991ae971a4c.png";